import s from './style.module.scss';

import PinInput from "react-pin-input";

import Card, { Card2 } from '../../../components/card';
import Input1 from '../../../components/input';
import Notif from '../../../components/notif';

import {wpUser,production} from '../../../../k';

import CopyInput from '../../../components/copyinput';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';

import { useRef, useState, useEffect } from 'react';
import SubmitBtn from '../../../components/submit';
import { loaderPostFetch,gfUrl } from '../util';

import { useActionData, useSubmit } from 'react-router-dom';

export async function paction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const contact = await loaderPostFetch(`api/users.php`, formData);

  return contact;
}

export async function ploader({ params }) {
  const formData = new FormData();
  formData.append('getpin', 'getpin');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }
  const profile = await loaderPostFetch(`api/users.php`, formData);

  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, profile };
}

export default function PinIndex() {
  //const { profile } = useLoaderData();

  let submit = useSubmit();
  let actionData = useActionData();

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  const [t, sT] = useState("Create a transaction pin");
  const [su, sS] = useState("Please generate a secure PIN to be used for <br/>transactions.");

  const [pin, setPin] = useState("");
  const [cpin, setCPin] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const picForm=useRef();
  const [sub, setSub] = useState(false);
  const [dis, setDis] = useState(true);

  useEffect(() => { 
    if (actionData) {
      let s = actionData;
      if (s?.status) {
        if (s?.status) {
          sN({ ...n, display: true, type: 'success', msg: 'We have detected that the PIN you entered does not match. Please Re-enter PIN' });
        } else {
          sN({ ...n, display: true, type: 'error', msg: 'Something went wrong!' });
        }
      } 
      setTimeout(() => {
        sN({ display: false, type: 'success', msg: `` });
      }, 3000);
    }
  }, [actionData]);

  const handlePinComplete = (value) => {
    
    setPin(value);
    if (sub) {
      setDis(false);
    }else{
      setCPin(value);
    }
  };

  const handleSub=()=>{
    console.log({cpin,pin});
    if (cpin==pin) {
      //submit
      console.log({cpin,pin},3);

      let token = window.localStorage.getItem('baUid');
      /*submit({ pin,token,getpin: 'getpin' }, {
        method: "post",
        action: gfUrl(`api/users.php`),
        encType: "application/x-www-form-urlencoded",
      });*/

      const formData = new FormData();

      let tok = window.localStorage.getItem('baUid');
      if (tok != null) {
        formData.append('pin', pin);
        formData.append('token', tok);
        formData.append('updatepin', 'updatepin');
        loaderPostFetch(`api/users.php`, formData).then((b)=>{

          sN({ display: true, type: 'success', msg: 'Your transaction PIN has been successfully created.' });
      
        }).catch((e)=>{

          sN({ display: true, type: 'error', msg: 'We have detected that the PIN you entered does not match. Please Re-enter PIN.' });
      
        });

        setTimeout(() => {
          sN({ display: false, type: 'success', msg: `` });
          //window.location.href = `${wpUser}/dashboard`;
          window.location.href = `${wpUser}/`;
        }, 3000);
      }


    }else{
      sN({ display: true, type: 'error', msg: 'We have detected that the PIN you entered does not match. Please Re-enter PIN.' });
       
      setTimeout(() => {
        sN({ display: false, type: 'success', msg: `` });
      }, 3000);
    }
  }
  let ele = useRef();
  let ele2 = useRef();

  const handleLogin = () => {
    if (pin.length==4) {
      sT("Re-enter to confirm pin ");
      sS("Please input your PIN again to confirm its <br/>accuracy.");
      setSub(true);
      ele.clear();
    }
    /*
    // Validate the entered PIN
    if (pin === correctPin) {
      // PIN is correct
      setSuccessMessage("🎉 Welcome back! Login successful!");
      setErrorMessage("");
      console.log("User logged in successfully");

    } else {
      // PIN is incorrect
      setErrorMessage("❌ Incorrect PIN. Please try again.");
      setSuccessMessage("");
      console.log("Incorrect PIN attempt");
    }


          onChange={(event) => {
            submit(event.currentTarget);
          }}*/
  };

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <div> 

        <Form 
          id="h"
          ref={picForm}
          method="post"
        >
        <input type="hidden" name="updatepin" value="updatepin" />

        <div className={s.cardd} >

          <div className={s.c}>
            <div className={s.icon}></div>
          </div>


          <div className={s.t}>{t}</div>
          <div className={s.s} dangerouslySetInnerHTML={{__html: su}}></div>

        {/*color: $color-black;
        text-align: center;
        font-feature-settings: 'clig' off, 'liga' off; 
        line-height: 22.479px; 
        letter-spacing: -0.899px;
        */}

        {(!sub) ?

          <PinInput
            ref={(n) => (ele = n)} /*Set ref */
            onComplete={handlePinComplete}
            length={4}
            focus 
            inputMode="number"
            secret
            secretDelay={500}
            inputStyle={{
              border: "2px solid #3498db", // Customize the border color
              borderRadius: "8px", // Adjust border radius
              fontSize: "14px", // Change font size
              fontStyle: "normal",
              fontFamily: "Inter",
              fontWeight: "500",
              padding: "5px", // Add some padding
              margin: "5px", // Adjust margin
            }}
            inputFocusStyle={{ borderColor: "lightgray" }}
          />

          :

          <PinInput
            ref={(n) => (ele2 = n)} /*Set ref */
            onComplete={handlePinComplete}
            length={4} 
            inputMode="number"
            secret
            secretDelay={500}
            inputStyle={{
              border: "2px solid #3498db", // Customize the border color
              borderRadius: "8px", // Adjust border radius
              fontSize: "14px", // Change font size
              fontStyle: "normal",
              fontFamily: "Inter",
              fontWeight: "500",
              padding: "5px", // Add some padding
              margin: "5px", // Adjust margin
            }}
            inputFocusStyle={{ borderColor: "lightgray" }}
          />
        }
          <>{sub?<><div className={s.btnn} onClick={handleSub} >Confirm</div>
        {/*<input type="submit" className={s.btnn} disabled={dis} value="Confirm" />*/}</>
        :
          <div className={s.btnn} onClick={handleLogin} >Confirm</div>}</>

        </div>

        </Form>
 
 
      </div>
    </>
  );
}